


<div class="email-field" (click)="setFocusToSearch()">
    <div class="alert pill selected-client" [ngClass]="{'primary-border-color': contactIsSelected(ec)}" *ngFor="let ec of emailContactList" (click)="$event.stopPropagation()">
        <span *ngIf="ec.name?.length > 0 else noName" [ngClass]="hasValidEmailFormat(ec) ? 'validEmail' : 'invalidEmail'">{{ec.name}} ({{ec.email}})
        </span>
        <ng-template #noName>
            <span [ngClass]="{'invalidEmail': !hasValidEmailFormat(ec)}">{{ec.email}}</span>
        </ng-template>
        <a (click)="removeContactFromList(ec); $event.stopPropagation()" title="Remove client"><fa-icon icon="close"></fa-icon></a>
    </div>

    <div class="float-start client-search">

        <input #search matInput [matAutocomplete]="auto" [formControl]="_form" class="search-input" (keydown)="onKeyDown($event)" (blur)="onBlur()">

        <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn" 
            (optionSelected)="selectClient($event.option.value)">
            <mat-option *ngIf="isLoading$ | async">
                <lgv-loading-indicator [CSSClass]="'Small'"></lgv-loading-indicator>
            </mat-option>
            <ng-container *ngIf="!(isLoading$ | async)">
                <mat-option *ngFor=" let x of clientResults$ | async " [value]="x" title="{{x.firstName}} {{x.lastName}}">
                    {{x.firstName}} {{x.lastName}}
                </mat-option>
            </ng-container>
        </mat-autocomplete>
    </div>

    <div class="clearfix"></div>
</div>
